module.exports = __webpack_public_path__ + "static/media/logo_artcafe.6ea34ae8.jpg";